import React, { useState, useContext } from "react";
import { StoreContext } from "../../context/StoreContext";
import { CompanyCard } from "./CompanyCard";

const ResultsList = ({ list }) => {
  const { state } = useContext(StoreContext);

  const [resultListingOptions, setResultListingOptions] = useState({
    showPopup: false,
    currentCertificates: [],
    currentPage: 0,
    pagination: [],//divideList(),
    totalPages: Math.ceil(list.length / 100),
  });

  function divideList() {
    let b = [];
    const listToUse = list;
    const a = Math.ceil(list.length / 100);
    for (var i = 0; i < a; i++) {
      b[i] = listToUse.splice(0, 100);
    }
    return b;
  }

  function togglePopup(certificates) {
    setResultListingOptions({
      ...resultListingOptions,
      showPopup: !resultListingOptions.showPopup,
      currentCertificates: certificates,
    });
  }

  function checkWebsite(company) {
    const url =
      company.Site && company.Site.length > 0
        ? company.Site
        : company.url_1 && company.url_1.length > 0
        ? company.url_1
        : "";
    return url.length > 0 ? `https://${url}` : "";
  }

  function getCertificates(regelingen) {
    if (regelingen !== null) {
      const IDs = regelingen.split(",").map((elem) => parseInt(elem, 10));
      const certificatesFilterd = state.search.suggestions.Kwaliteitsregelingen.filter(
        (element) => IDs.includes(element.Id)
      );
      return certificatesFilterd;
    } else {
      return [];
    }
  }

  function toggleMoreInfo(e) {
    e.currentTarget.parentNode.classList.toggle("more-info-active");
  }

  if (document.querySelector("#prefilled-term")) {
    list = list.slice(0, 3);
  }

  function loadMoreCards() {
    const nextPage = resultListingOptions.currentPage++;
    if (nextPage < resultListingOptions.totalPages) {
      setResultListingOptions({
        ...resultListingOptions,
        currentPage: nextPage,
      });
    }
  }

  function checkVisibility(e) {
    
    return false;
  }

  return (
    <>
      {list.map((result, index) => (
        <CompanyCard
          key={index}
          companyDetail={result}
          checkWebsite={checkWebsite}
          toggleMoreInfo={toggleMoreInfo}
          togglePopup={togglePopup}
          getCertificates={getCertificates}
          visible={(e) => checkVisibility(e)}
        />
      ))}

      <div
        className={
          resultListingOptions.showPopup ? "show popup-info" : "hide popup-info"
        }
      >
        <div
          className="close"
          data-remove-if-empty="ignore"
          onClick={(e) => togglePopup(e, [])}
        />
        <h3>Certificaten en regelingen</h3>
        <p>
          Certificaten en regelingen zijn een teken van bewezen vakmanschap.
          Heeft dit bedrijf de beste papieren om uw opdracht uit te voeren?
        </p>
        <a
          className="btn"
          href="https://www.technieknederland.nl/kwaliteit/certificaten-en-erkenningen"
        >
          Lees meer over certificering
        </a>
        <ul>
          {resultListingOptions.currentCertificates.length > 0 &&
            resultListingOptions.currentCertificates.map(
              (certificate, index) => (
                <li key={(certificate, index)}>
                  <img
                    src={certificate.Logo}
                    title={certificate.Name}
                    width="32"
                  />
                  <span className="certificate-name">{certificate.Name}</span>
                </li>
              )
            )}
        </ul>
      </div>
    </>
  );
};

export { ResultsList };

/*

        */